import { render } from "./SlideInPanel.vue?vue&type=template&id=400c41e6&scoped=true"
import script from "./SlideInPanel.vue?vue&type=script&lang=js"
export * from "./SlideInPanel.vue?vue&type=script&lang=js"

import "./SlideInPanel.vue?vue&type=style&index=0&id=400c41e6&lang=scss&scoped=true"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-400c41e6"]])

export default __exports__